module.exports = __webpack_public_path__ + "img/flow-sm.842ea433.svg";